import React from "react";
import { Loading } from "@thecb/components";
import styled from "styled-components";

const Wrapper = styled.div.attrs((props) => ({ ...props }))``;

const Overlay = styled.div.attrs((props) => ({ ...props }))`
  z-index: ${({ zIndex }) => zIndex};
  position: fixed;
  height: 100%;
  width: 100%;
  background: ${({ opacity }) => `rgba(0, 0, 0, ${opacity})`};
  transition: ${({ fadeSpeed }) => `visibility 0s, opacity ${fadeSpeed}ms ease-in`};
  visibility: ${({ active }) => (active ? "visible" : "hidden")};
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

const LoadingOverlay = ({
  fadeSpeed = 250,
  loadingOverlayIsActive,
  opacity = 0.7,
  zIndex = 1000,
  children,
}) => (
  <Wrapper dataQa="loading-overlay-wrapper">
    <Overlay
      active={loadingOverlayIsActive}
      dataQa="loading-overlay-overlay"
      fadeSpeed={fadeSpeed}
      opacity={opacity}
      zIndex={zIndex}
    >
      <Loading />
    </Overlay>
    {children}
  </Wrapper>
);

export default LoadingOverlay;
